<template>
  <fragment>
    <div
      class="mt-3 d-flex align-items-center justify-content-between min_height_55 font_Montserrat"
    >
      <div class="d-flex align-items-center">
        <span class="v3_color_teal font_size_850rem font_weight_bold">
          Step 2: Filters
          <span v-if="numberOfSelectedFilters">
            ({{ numberOfSelectedFilters }})
          </span>
        </span>
      </div>
      <div>
        <!-- Apply button -->
        <b-btn
          v-if="isApplyButtonVisible"
          variant="v2_navy_outline"
          size="sm"
          class="survey-results__apply-button"
          @click="onFiltersApply"
        >
          Apply
        </b-btn>
        <b-btn
          v-if="numberOfSelectedFilters"
          variant="v2_navy_outline"
          size="sm"
          class="survey-results__apply-button ml-1"
          @click="onClearAll"
        >
          Clear All
        </b-btn>
      </div>
    </div>
    <div
      class="filters-selector__section mt-3"
      v-if="isMembershipSectionVisible"
    >
      <div class="filters-selector__section_question h-100">
        <div
          class="d-flex justify-content-between align-items-center filters-selector__question-label p-0"
        >
          <div
            class="filters-selector__section-header py-1 d-flex align-items-center v3_color_black_knight"
          >
            Membership Type
          </div>
          <div
            class="toggle-collapse clickable collapsed h-100"
            v-b-toggle="'collapse_membership_type'"
          >
            <i class="mdi mdi-chevron-up" />
          </div>
        </div>
      </div>
      <b-collapse id="collapse_membership_type" role="tabpanel">
        <div v-for="{ text, value } in membershipOptions" :key="value">
          <b-row class="py-1 filters-selector__section_question">
            <b-col
              :id="`membership-filter-${value}`"
              class="d-flex justify-content-start align-items-center"
            >
              <b-form-checkbox
                class="v3_control_checkbox_small"
                :unchecked-value="false"
                :value="true"
                @change="
                  (checkboxVal) =>
                    onMembershipCheckboxChange(value, checkboxVal)
                "
                :checked="membershipTypeIds.includes(value)"
                :disabled="disabled"
              >
                {{ text }}
              </b-form-checkbox>
              <b-tooltip v-if="disabled" :target="`membership-filter-${value}`">
                Filtering is disabled until the study is completed.
              </b-tooltip>
            </b-col>
          </b-row>
        </div>
      </b-collapse>
    </div>
   
    <div class="filters-selector__section d-flex justify-content-between align-items-center" v-if="isUser">
      <div class="filters-selector__question-label mr-3" id="similar-area-options-toggle">
        Filter Data for Cities Like Mine
      </div>
      <div
            class="toggle-collapse clickable collapsed h-100"
            v-b-toggle="'similar-area-options-toggle'"
            v-if="derivedVariables.length > 1"
          >
            <i class="mdi mdi-chevron-up" />
          </div>
    </div>
    <b-collapse              
      id="similar-area-options-toggle" :visible="derivedVariables.length === 1"
      v-if="isUser"
    >
      <div class="d-flex align-items-center">
          <div class="v2_phairify-select-wrapper mr-2">
              <b-form-select
                  class="phairify-border-grey region-select same-height"
                  :value="areaCode && areaCode[0] ? areaCode[0] : null"
                  :options="this.cbsaValues"
                  :disabled="!this.cbsaValues"
                  @change="onAreaCodeInput(derivedVariables,$event)"                
              >
                  <template slot="first">
                      <option :value="null" disabled>
                          -- Select an area --
                      </option>
                  </template>
              </b-form-select>
          </div>
          <b-button
            variant="v3_teal_outline"
            @click="onAreaCodeInput(derivedVariables,null)"
            :disabled="!isOpen"
          >
            Reset
          </b-button>

          <i
              class="mdi mdi-information-outline clickable"
              aria-hidden="true"
              v-b-tooltip.hover
              title="Select city of interest to see data for comparable locations, based on a basket of variables (population, rural/urban, income)"            
          />
      </div>
    </b-collapse>
    <!------ Specialty Filter Start ------------->
    <div class="filters-selector__section d-flex justify-content-between align-items-center" v-if="isUser">
      <div class="filters-selector__question-label mr-3" id="similar-area-options-toggle">
        Specialty&nbsp;
         <span v-if="getNumberOfSelectedSpecialtyFilters()">
            ({{ getNumberOfSelectedSpecialtyFilters() }})
          </span>
      </div>
      <div
            class="toggle-collapse clickable collapsed h-100"
            v-b-toggle="'derived-toggle-specialty'"
            v-if="derivedVariables.length > 1"
          >
            <i class="mdi mdi-chevron-up" />
          </div>
    </div>
    <b-collapse id="derived-toggle-specialty" :visible="derivedVariables.length === 1">
        <div
          v-if="derivedVariables[0]"
          :key="derivedVariables[0].derivedVariable.name"
          class="px-0"
        >
          <template v-if="derivedVariables[0].derivedVariable.name === 'userSpecialtyId'">
            <b-row :key="s.id" class="py-1" v-for="s in specialties">
              <b-col
                class="d-flex justify-content-start align-items-center"
              >
                <item-with-tooltip
                  :name="`derived-specialty-filter-${s.id}`"
                  :active="disabled"
                  message="Filtering is disabled until the study is completed."
                >
                  <b-form-checkbox
                    class="v3_control_checkbox_small"
                    :unchecked-value="0"
                    :value="1"
                    :checked="derivedVarValues[`userSpecialtyId_${s.id}`]"
                    :disabledOld="disabled"
                    @input="
                      onDerVarInput(derivedVariables[0], `userSpecialtyId`, s.id, $event)
                    "
                  >
                    {{ s.title }}
                  </b-form-checkbox>
              </item-with-tooltip>
            </b-col>
          </b-row>
        </template>
      </div>
    </b-collapse>
    <!------ Specialty Filter End ------------->

    <!------ Subspecialty Filter Start ------------->
    <div class="filters-selector__section d-flex justify-content-between align-items-center" v-if="isUser">
      <div class="filters-selector__question-label mr-3" id="similar-area-options-toggle">
        Subspecialty&nbsp;
         <span v-if="getNumberOfSelectedSubspecialtyFilters()">
            ({{ getNumberOfSelectedSubspecialtyFilters() }})
          </span>
      </div>
      <div
            class="toggle-collapse clickable collapsed h-100"
            v-b-toggle="'derived-toggle-subspecialty'"
            v-if="derivedVariables.length > 1"
          >
            <i class="mdi mdi-chevron-up" />
          </div>
    </div>
    <b-collapse id="derived-toggle-subspecialty" :visible="derivedVariables.length === 1">
        <div
          v-if="derivedVariables[1]"
          :key="derivedVariables[1].derivedVariable.name"
          class="px-0"
        >
      </div>
       <template>
        <b-row :key="s.id" class="py-1" v-for="s in subspecialties">
          <b-col
            class="d-flex justify-content-start align-items-center"
          >
            <item-with-tooltip
              :name="`derived-specialty-filter-${s.id}`"
              :active="disabled"
              message="Filtering is disabled until the study is completed."
            >
              <b-form-checkbox
                class="v3_control_checkbox_small"
                :unchecked-value="0"
                :value="1"
                :checked="derivedVarValues[`userSubSpecialtyId_${s.id}`]"
                :disabledOld="disabled"
                @input="
                  onDerVarInput(derivedVariables[1], `userSubSpecialtyId`, s.id, $event)
                "
              >
                {{ s.title }}
              </b-form-checkbox>
            </item-with-tooltip>
          </b-col>
        </b-row>
      </template>
    </b-collapse>
    <!------ Subspecialty Filter End ------------->
    <div class="filters-selector__section">
      <div v-if="derivedVariables.length > 0" class="h-100">
        <div
          class="d-flex justify-content-between align-items-center filters-selector__question-label p-0"
        >
          <div
            class="filters-selector__section-header py-1 d-flex align-items-center"
          >
            Profile&nbsp;
            <span v-if="getNumberOfSelectedProfileSectionFilters()">
              ({{ getNumberOfSelectedProfileSectionFilters() }})
            </span>
          </div>
          <div
            class="toggle-collapse clickable collapsed h-100"
            v-b-toggle="'derived-toggle'"
            v-if="derivedVariables.length > 1"
          >
            <i class="mdi mdi-chevron-up" />
          </div>
        </div>
      </div>
      <b-collapse id="derived-toggle" :visible="derivedVariables.length === 1">
        <div
          v-for="dvm in derivedVariables"
          :key="dvm.derivedVariable.name"
          class="px-0"
        >
          <!-- <template
            v-if="
              !(
                dvm.derivedVariable.name === 'userSpecialtyId' &&
                !isSpecialtyFilterVisible
              ) &&
              !(
                dvm.derivedVariable.name === 'userSubSpecialtyId' &&
                !isSpecialtyFilterVisible
              )
            "
          > -->
           <template
            v-if="
              !(
                dvm.derivedVariable.name === 'userSpecialtyId'
              ) &&
              !(
                dvm.derivedVariable.name === 'userSubSpecialtyId'
              )
            "
          >
            <div class="py-1 filters-selector__section_question">
              <div
                class="d-flex justify-content-between align-items-center filters-selector__question-label p-0"
              >
                <div>
                  <span class="font_size_875rem v3_color_black_knight">
                    <strong>{{ dvm.derivedVariable.title }}</strong
                    >&nbsp;
                    <span
                      v-if="
                        getNumberOfSelectedProfileFilters(
                          dvm.derivedVariable.name
                        )
                      "
                    >
                      ({{
                        getNumberOfSelectedProfileFilters(
                          dvm.derivedVariable.name
                        )
                      }})
                    </span>
                  </span>
                </div>
                <!-- expand to show vars -->
                <div
                  class="toggle-collapse clickable collapsed"
                  v-b-toggle="
                    `derived-options-toggle-${dvm.derivedVariable.name}`
                  "
                >
                  <i class="mdi mdi-chevron-up" />
                </div>
              </div>
            </div>
            <b-collapse
              :id="`derived-options-toggle-${dvm.derivedVariable.name}`"
            >
             <!--  <template v-if="dvm.derivedVariable.name === 'userSpecialtyId'">
                <b-row :key="s.id" class="py-1" v-for="s in specialties">
                  <b-col
                    class="d-flex justify-content-start align-items-center"
                  >
                    <item-with-tooltip
                      :name="`derived-specialty-filter-${s.id}`"
                      :active="disabled"
                      message="Filtering is disabled until the study is completed."
                    >
                      <b-form-checkbox
                        class="v3_control_checkbox_small"
                        :unchecked-value="0"
                        :value="1"
                        :checked="derivedVarValues[`userSpecialtyId_${s.id}`]"
                        :disabledOld="disabled"
                        @input="
                          onDerVarInput(dvm, `userSpecialtyId`, s.id, $event)
                        "
                      >
                        {{ s.title }}
                      </b-form-checkbox>
                    </item-with-tooltip>
                  </b-col>
                </b-row>
              </template> -->
              <!-- <template v-if="dvm.derivedVariable.name === 'userSubSpecialtyId'">
                <b-row :key="s.id" class="py-1" v-for="s in subspecialties">
                  <b-col
                    class="d-flex justify-content-start align-items-center"
                  >
                    <item-with-tooltip
                      :name="`derived-specialty-filter-${s.id}`"
                      :active="disabled"
                      message="Filtering is disabled until the study is completed."
                    >
                      <b-form-checkbox
                        class="v3_control_checkbox_small"
                        :unchecked-value="0"
                        :value="1"
                        :checked="derivedVarValues[`userSubSpecialtyId_${s.id}`]"
                        :disabledOld="disabled"
                        @input="
                          onDerVarInput(dvm, `userSubSpecialtyId`, s.id, $event)
                        "
                      >
                        {{ s.title }}
                      </b-form-checkbox>
                    </item-with-tooltip>
                  </b-col>
                </b-row>
              </template> -->
              <template v-if="dvm.derivedVariable.name === 'userGender'">
                <b-row
                  :key="opt.value"
                  class="py-1"
                  v-for="opt in genderOptions"
                >
                  <b-col
                    class="d-flex justify-content-start align-items-center"
                  >
                    <item-with-tooltip
                      :name="`derived-gender-filter-${opt.value}`"
                      :active="disabled"
                      message="Filtering is disabled until the study is completed."
                    >
                      <b-form-checkbox
                        class="v3_control_checkbox_small"
                        :unchecked-value="0"
                        :value="1"
                        :checked="derivedVarValues[`userGender_${opt.value}`]"
                        :disabledOld="disabled"
                        @input="
                          onDerVarInput(dvm, `userGender`, opt.value, $event)
                        "
                      >
                        {{ opt.text }}
                      </b-form-checkbox>
                    </item-with-tooltip>
                  </b-col>
                </b-row>
              </template>
              <template
                v-else-if="dvm.derivedVariable.name === 'userEthnicity'"
              >
                <b-row
                  :key="opt.value"
                  class="py-1"
                  v-for="opt in ethnicityOptions"
                >
                  <b-col
                    class="d-flex justify-content-start align-items-center"
                  >
                    <item-with-tooltip
                      :name="`derived-ethnicity-filter-${opt.value}`"
                      :active="disabled"
                      message="Filtering is disabled until the study is completed."
                    >
                      <b-form-checkbox
                        class="v3_control_checkbox_small"
                        :unchecked-value="0"
                        :value="1"
                        :checked="
                          derivedVarValues[`userEthnicity_${opt.value}`]
                        "
                        :disabledOld="disabled"
                        @input="
                          onDerVarInput(dvm, `userEthnicity`, opt.value, $event)
                        "
                      >
                        {{ opt.text }}
                      </b-form-checkbox>
                    </item-with-tooltip>
                  </b-col>
                </b-row>
              </template>
              <template
                v-else-if="dvm.derivedVariable.name === 'userVisaStatus'"
              >
                <b-row
                  :key="opt.value"
                  class="py-1"
                  v-for="opt in visaStatusOptions"
                >
                  <b-col
                    class="d-flex justify-content-start align-items-center"
                  >
                    <item-with-tooltip
                      :name="`derived-visa-status-filter-${opt.value}`"
                      :active="disabled"
                      message="Filtering is disabled until the study is completed."
                    >
                      <b-form-checkbox
                        class="v3_control_checkbox_small"
                        :unchecked-value="0"
                        :value="1"
                        :checked="
                          derivedVarValues[`userVisaStatus_${opt.value}`]
                        "
                        :disabledOld="disabled"
                        @input="
                          onDerVarInput(
                            dvm,
                            `userVisaStatus`,
                            opt.value,
                            $event
                          )
                        "
                      >
                        {{ opt.text }}
                      </b-form-checkbox>
                    </item-with-tooltip>
                  </b-col>
                </b-row>
              </template>
              <template
                v-else-if="dvm.derivedVariable.name === 'userUSVeteran'"
              >
                <b-row
                  :key="opt.value"
                  class="py-1"
                  v-for="opt in isUSVeteranOptions"
                >
                  <b-col
                    class="d-flex justify-content-start align-items-center"
                  >
                    <item-with-tooltip
                      :name="`derived-us-veteran-filter-${opt.value}`"
                      :active="disabled"
                      message="Filtering is disabled until the study is completed."
                    >
                      <b-form-checkbox
                        class="v3_control_checkbox_small"
                        :unchecked-value="0"
                        :value="1"
                        :checked="
                          derivedVarValues[`userUSVeteran_${opt.value}`]
                        "
                        :disabledOld="disabled"
                        @input="
                          onDerVarInput(dvm, `userUSVeteran`, opt.value, $event)
                        "
                      >
                        {{ opt.text }}
                      </b-form-checkbox>
                    </item-with-tooltip>
                  </b-col>
                </b-row>
              </template>
              <template v-else-if="dvm.derivedVariable.name === 'userZipcode'">
                <location-filter
                  :location-filter-data="derivedVarValues[`userZipcode`]"
                  :disabledOld="disabled"
                  @set-location-filter="onLocationInput(dvm, $event)"
                  @clear-location-filter="onLocationInput(dvm, null)"
                />
              </template>
            </b-collapse>
          </template>
        </div>
      </b-collapse>
    </div>

    <!-- question variable list -->
    <template v-for="sm in sections">
      <div
        v-if="
          !sm.section.is_module ||
          (sm.section.is_module && isCompletedModule(sm.section.id))
        "
        :key="sm.section.id"
        class="filters-selector__section border-top"
        :set="(questions = getAvailableQuestions(sm))"
      >
        <div v-if="derivedVariables.length > 0" class="h-100">
          <div
            class="d-flex justify-content-between align-items-center filters-selector__question-label p-0"
          >
            <div
              class="filters-selector__section-header py-1 d-flex align-items-center"
            >
              {{ sm.section.title }}&nbsp;
              <span v-if="getNumberOfSelectedFiltersForSection(sm)">
                ({{ getNumberOfSelectedFiltersForSection(sm) }})
              </span>
            </div>
            <div
              class="toggle-collapse clickable collapsed"
              v-b-toggle="`section_toggle_${sm.section.id}`"
            >
              <i class="mdi mdi-chevron-up" />
            </div>
          </div>
        </div>
        <b-collapse :id="`section_toggle_${sm.section.id}`">
          <div v-for="qm in questions" :key="qm.question.id">
            <!-- row to select all vars for question -->
            <div class="filters-selector__section_question">
              <div
                class="d-flex justify-content-between align-items-center filters-selector__question-label p-0"
              >
                <div
                  v-b-popover.click.right="qm.question.prompt"
                  class="v3_color_black_knight"
                >
                  {{ qm.question.label }}&nbsp;
                  <span
                    v-if="getNumberOfSelectedFiltersForQuestion(qm.question)"
                    >({{
                      getNumberOfSelectedFiltersForQuestion(qm.question)
                    }}s)</span
                  >
                </div>
                <!-- expand to show vars -->
                <div
                  class="toggle-collapse clickable collapsed h-100"
                  v-if="qm.question.variables.length > 0"
                  v-b-toggle="`question-toggle-${qm.question.id}`"
                >
                  <i class="mdi mdi-chevron-up font_size_1250rem" />
                </div>
              </div>
            </div>

            <!-- rows to select individual vars -->
            <b-collapse :id="`question-toggle-${qm.question.id}`">
              <fragment v-if="qm.question.type === 'YES_NO'">
                <b-row class="py-1">
                  <item-with-tooltip
                    :name="`question-filter-${qm.question.id}`"
                    :active="disabled"
                    message="Filtering is disabled until the study is completed."
                  >
                    <b-col
                      cols="12"
                      class="d-flex justify-content-start align-items-center"
                    >
                      <b-form-checkbox
                        class="v3_control_checkbox_small d-flex"
                        :unchecked-value="false"
                        :value="true"
                        :disabledOld="disabled"
                        v-model="qm.variables[0].selected"
                      />
                      <b-form-radio-group
                        class="v3_control_radio_group_small"
                        :disabledOld="!qm.variables[0].selected || disabled"
                        v-model="
                          variableValues[
                            `${qm.question.id}_${qm.variables[0].variable.id}`
                          ]
                        "
                      >
                        <b-form-radio :value="1">Yes</b-form-radio>
                        <b-form-radio :value="0">No</b-form-radio>
                      </b-form-radio-group>
                    </b-col>
                  </item-with-tooltip>
                </b-row>
              </fragment>              
              <fragment
                v-else
                v-for="vm in qm.variables"
                :set="
                  (withChild = [
                    'CONFIRMATION',
                    'SLIDER',
                    'MULTI_VARIABLE_SELECT_ONE',
                  ].includes(qm.question.type))
                "
                :key="vm.variable.id"
              >
                <div class="ml-2">
                  <b-row class="py-1" v-if="qm.question.variables.length > 1">
                    <b-col
                      class="d-flex justify-content-start align-items-center"
                    >
                      <template v-if="!withChild">
                        <item-with-tooltip
                          :name="`question-filter-${qm.question.id}-${vm.variable.id}`"
                          :active="disabled"
                          message="Filtering is disabled until the study is completed."
                        >
                          <b-form-checkbox
                            class="v3_control_checkbox_small"
                            v-if="!withChild"
                            :unchecked-value="false"
                            :value="true"
                            :disabledOld="disabled"
                            v-model="vm.selected"
                          >
                            <div
                              class="filters-selector__variable-label v3_color_black_knight"
                            >
                              {{
                                vm.variable.short_label ||
                                vm.variable.input_label
                              }}
                            </div>
                          </b-form-checkbox>
                        </item-with-tooltip>
                      </template>
                      <template v-else>
                        <div
                          class="d-flex justify-content-between w-100 align-items-center"
                        >
                          <div
                            class="filters-selector__variable-label v3_color_black_knight`"
                          >
                            {{
                              vm.variable.short_label || vm.variable.input_label
                            }}
                          </div>
                          <div
                            class="toggle-collapse clickable collapsed h-100"
                            v-b-toggle="
                              `question-var-toggle-${qm.question.id}_${vm.variable.id}`
                            "
                          >
                            <i class="mdi mdi-chevron-up" />
                          </div>
                        </div>
                      </template>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12">
                      <b-collapse
                        v-if="withChild"
                        :id="`question-var-toggle-${qm.question.id}_${vm.variable.id}`"
                        :visible="qm.question.variables.length === 1"
                      >
                        <item-with-tooltip
                          :name="`question-filter-${qm.question.id}-${vm.variable.id}`"
                          :active="disabled"
                          placement="topleft"
                          message="Filtering is disabled until the study is completed."
                        >
                          <!-- CONFIRMATION filter -->
                          <b-row v-if="qm.question.type === 'CONFIRMATION'">
                            <b-col
                              cols="12"
                              class="d-flex justify-content-start align-items-center"
                            >
                              <b-form-checkbox
                                class="v3_control_checkbox_small"
                                :unchecked-value="false"
                                :value="true"
                                :disabledOld="disabled"
                                v-model="vm.selected"
                              />
                              <confirmation-filter
                                :min-value="
                                  variableValues[
                                    `${qm.question.id}_${vm.variable.id}_minmax`
                                  ].min
                                "
                                :max-value="
                                  variableValues[
                                    `${qm.question.id}_${vm.variable.id}_minmax`
                                  ].max
                                "
                                :variable="vm.variable"
                                :with-label="qm.question.variablesCount > 1"
                                :disabledOld="!vm.selected || disabled"
                                @input-min="
                                  variableValues[
                                    `${qm.question.id}_${vm.variable.id}_minmax`
                                  ].min = $event
                                "
                                @input-max="
                                  variableValues[
                                    `${qm.question.id}_${vm.variable.id}_minmax`
                                  ].max = $event
                                "
                              />
                            </b-col>
                          </b-row>
                          <!-- SLIDER filter -->
                          <b-row v-else-if="qm.question.type === 'SLIDER'">
                            <b-col
                              cols="12"
                              class="d-flex justify-content-start align-items-center"
                            >
                              <b-form-checkbox
                                class="v3_control_checkbox_small"
                                :unchecked-value="false"
                                :value="true"
                                :disabledOld="disabled"
                                v-model="vm.selected"
                              />
                              <slider-filter
                                class="w-100"
                                :uid="`${qm.question.id}_${vm.variable.id}`"
                                :min-value="
                                  variableValues[
                                    `${qm.question.id}_${vm.variable.id}_minmax`
                                  ].min
                                "
                                :max-value="
                                  variableValues[
                                    `${qm.question.id}_${vm.variable.id}_minmax`
                                  ].max
                                "
                                :variable="vm.variable"
                                :disabledOld="!vm.selected || disabled"
                                @slider-updated="onSliderUpdated(vm, $event)"
                              />
                            </b-col>
                          </b-row>
                          <b-row
                            v-else-if="
                              qm.question.type === 'MULTI_VARIABLE_SELECT_ONE'
                            "
                          >
                            <b-form-group class="col-11 offset-1">
                              <b-form-checkbox-group
                                v-model="
                                  variableValues[
                                    `${qm.question.id}_${vm.variable.id}`
                                  ]
                                "
                                :name="`${vm.variable.id}`"
                                :disabledOld="disabled"
                                @change="onMultiSelectChange(vm, $event)"
                                stacked
                              >
                                <b-form-checkbox
                                  v-for="(option, oIndex) in vm.variable
                                    .variableOptions"
                                  class="v3_control_checkbox_small w-auto"
                                  :value="option.id"
                                  :key="option.id + oIndex"
                                >
                                  {{ option.name }}
                                </b-form-checkbox>
                              </b-form-checkbox-group>
                            </b-form-group>
                          </b-row>
                        </item-with-tooltip>
                      </b-collapse>
                    </b-col>
                  </b-row>
                </div>
              </fragment>              
            </b-collapse>
          </div>
        </b-collapse>
      </div>
    </template>
  </fragment>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import Questionnaire from '@/providers/Questionnaire';
import ConfirmationFilter from '@/components/survey/results/select-filters/ConfirmationFilter';
import SliderFilter from '@/components/survey/results/select-filters/SliderFilter';
import { QUESTION_TYPES, VISA_STATUSES_LABELS } from '@/store';
import LocationFilter from '@/components/survey/results/select-filters/LocationFilter';
import ItemWithTooltip from '@/components/ui-elements/ItemWithTooltip';
import Api from '@/providers/Api';

export default {
  name: 'SelectFilters',
  components: {
    ConfirmationFilter,
    SliderFilter,
    LocationFilter,
    ItemWithTooltip,
  },
  props: {
    questionnaire: {
      type: Object,
      required: true,
    },
    initialFilters: {
      type: Object,
      required: true,
    },
    initialFilterValues: {
      type: Object,
      required: true,
    },
    isMembershipSectionVisible: {
      type: Boolean,
      default: false,
    },
    membershipOptions: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
    selectedSection: {
      validator: (prop) => typeof prop === 'number' || prop === null,
      default: null,
    },
    isSpecialtyFilterVisible: {
      type: Boolean,
      default: true,
    },
    completedModules: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data: function () {
    const selectedNames = (this.initialFilters || {}).derivedVarNames || [];
    const selectedQsIds = (this.initialFilters || {}).questionIds || [];
    const selectedVIds = (this.initialFilters || {}).variableIds || [];       
    let sections = this.questionnaire.sections;
    if (this.selectedSection) {
      const section = this.questionnaire.sections.find(
        (s) => s.id === this.selectedSection
      );
      sections = [section];
    }
    let dataSections = Questionnaire.getQuestionnaireSections(
      sections,
      selectedQsIds,
      selectedVIds
    );
    return {
      derivedVariables: Questionnaire.getDerivedVariables(selectedNames),
      derivedVarValues: (this.initialFilterValues || {}).derivedVarValues || {},
      membershipTypeIds: (this.initialFilters || {}).membershipTypeIds || [],
      oldFilters: null,
      sections: dataSections,
      isApplyButtonVisible: false,
      localVariableValues:
        (this.initialFilterValues || {}).variableValues || {},
      cbsaValues : [],
      isOpen: false,
      areaCode: [],
      checkedSpecialtyIds: [],
      initialSpecialtyIds: [],
    };
  },
  mounted: function () {
    this.oldFilters = cloneDeep(this.getFilters());
    this.$emit('set-tags', this.getTags());
  },
  computed: {
    variableValues: function () {
      return this.sections.reduce((acc, qs) => {
        qs.questions.forEach(({ question }) => {
          question.variables.forEach((vm) => {
            if (
              question.type === QUESTION_TYPES.SLIDER ||
              question.type === QUESTION_TYPES.CONFIRMATION
            ) {
              const key = `${question.id}_${vm.id}_minmax`;
              const values = (this.localVariableValues || {})[key] || {};
              const min = values.min || vm.min || 0;
              const step = vm.step || 1;
              acc[key] = {
                min: min,
                max: values.max || vm.max || min + step,
              };
            } else if (
              question.type === QUESTION_TYPES.MULTI_VARIABLE_SELECT_ONE
            ) {
              const key = `${question.id}_${vm.id}`;
              acc[key] =
                ((this.initialFilterValues || {}).variableValues || {})[key] ||
                [];
            } else {
              const key = `${question.id}_${vm.id}`;
              acc[key] =
                ((this.initialFilterValues || {}).variableValues || {})[key] ||
                null;
            }
          });
        });
        return acc;
      }, {});
    },
    specialties: function () {
      let specialtiesData = this.$store.state.user &&
        this.$store.state.user.society &&
        Array.isArray(this.$store.state.user.society.specialties)
        ? this.$store.state.user.society.specialties
        : [];
        if(this.initialSpecialtyIds.length == 0){
          specialtiesData.forEach((s) => {
            this.initialSpecialtyIds.push(s.id);
          });
        }
      return specialtiesData;

       // let Data;
       // let specialtiesData = this.$store.state.specialtyOptions.filter(
       //  ({ specialty = null }) =>
       //    specialty && parseInt(specialty.societiesCount) > 0 && parseInt(specialty.usersCount) > 0
       //    && parseInt(specialty.jobProfilesCount) > 0
       //  );

       //  if(specialtiesData.length > 0){
       //    Data = specialtiesData.map(item => item.subspecialty);
       //    if(this.initialSpecialtyIds.length == 0){
       //    Data.forEach((s) => {
       //      this.initialSpecialtyIds.push(s.id);
       //    });
       //  }
       //  }else{
       //    Data = [];
       //  }

       //  return Data.map(item => item.subspecialty);
    },
    subspecialties: function () {
      let sub = [];
      let ar = this.checkedSpecialtyIds.length > 0 ? this.checkedSpecialtyIds : this.initialSpecialtyIds;
      //let uniqueSpecialtyIds = Array.from(new Set(this.checkedSpecialtyIds));
      ar.forEach((s) => {
        let filteredSubs = this.$store.state.subspecialtyOptions.filter(
          (subs) => (subs.subspecialty || {}).specialty_id === s
        ).filter(
          ({ subspecialty = null }) =>
            !this.filterUserCount || (subspecialty)
        );
        sub = sub.concat(filteredSubs);
      });
      // const sub = this.$store.state.subspecialtyOptions.filter(
      //   (subs) => (subs.subspecialty || {}).specialty_id === this.checkedSpecialtyIds
      // ).filter(
      //   ({ subspecialty = null }) =>
      //     !this.filterUserCount || (subspecialty)
      // );
      //console.log(JSON.stringify(sub.map(item => item.subspecialty)));
      if(sub.length > 0){
        return sub.map(item => item.subspecialty);
      }else{
        return [];
      }
      
    },
    genderOptions: function () {
      return this.$store.state.genderOptions.filter((o) => o.value !== null);
    },
    ethnicityOptions: function () {
      return this.$store.state.ethnicityOptions.filter((o) => o.value !== null);
    },
    visaStatusOptions: function () {
      return Object.keys(VISA_STATUSES_LABELS).map((key) => ({
        value: key,
        text: VISA_STATUSES_LABELS[key],
      }));
    },
    isUSVeteranOptions: function () {
      return [
        { value: 1, text: 'Yes' },
        { value: 0, text: 'No' },
      ];
    },
    numberOfSelectedFilters: function () {
      const { derivedVarValues } = this.getDerivedVariables();
      const { variableIds } = this.getVariables();
      const areaCodeValue = this.areaCode;
      return (
        (Object.keys(derivedVarValues).length || 0) + (variableIds.length || 0) + (areaCodeValue.length || 0)
      );
    },
    selectedVariableValues: function () {
      const { variableValues } = this.getVariables();
      return variableValues;
    },
    filters: function () {
      return this.getFilters();
    },
    variableTags: function () {
      return this.getVariableTags();
    },
    derivedTags: function () {
      return this.getDerivedTags();
    },
    isUser: function() {
      return (this.$store.getters.userIsMSSUser || this.$store.getters.userIsAdmin) ? true : false;
    },
  },
  methods: {
    updateSubspecialties(newValue, oldValue) {
      //console.log('checkedSpecialtyIds changed:', newValue);
      // Optionally perform additional logic when checkedSpecialtyIds changes
    },
    getData: async function () {      
      try {        
        this.cbsaValues = await Api.getCbsaClusterValues();                
        this.cbsaValues = this.cbsaValues.reduce((options, cbsa) => {        
        
          options.push({
            value: cbsa.cbsa_code,
            text: cbsa.cbsa_name,
          });
        
        return options;
      }, []);
      } catch (e) {
        console.log(e);
        this.$toasted.error('Unable to upload Area data', { duration: 3000 });
      }
    },
    getAvailableQuestions: function (section) {
      return section.questions;
    },
    questionToggled: function (qm, checked) {
      // select/deselect all variables
      qm.variables.forEach((_, index) => {
        this.$set(qm.variables[index], 'selected', checked);
        // vm.selected = checked;
      });
    },
    onMembershipCheckboxChange: function (membershipId, value) {
      if (value && !this.membershipTypeIds.includes(membershipId)) {
        this.membershipTypeIds.push(membershipId);
      } else if (!value) {
        this.membershipTypeIds = this.membershipTypeIds.filter(
          (id) => id !== membershipId
        );
      }
    },
    onSliderUpdated: function (variable, { uid, min, max }) {
      if (variable.selected) {
        if (this.localVariableValues[`${uid}_minmax`]) {
          this.$set(this.localVariableValues[`${uid}_minmax`], 'max', max);
          this.$set(this.localVariableValues[`${uid}_minmax`], 'min', min);
        } else {
          this.$set(this.localVariableValues, `${uid}_minmax`, {min, max});
        }
      } else {
        this.$delete(this.localVariableValues, `${uid}_minmax`);
      }
    },
    onDerVarInput: function (dvm, key, id, checked) {
      this.initialSpecialtyIds=[];
      if (checked) {
        if(key == 'userSpecialtyId') {
            this.checkedSpecialtyIds.push(id);
        }
        this.$set(this.derivedVarValues, `${key}_${id}`, checked);
      } else {
        this.popSpecialtyId(id);
        this.$delete(this.derivedVarValues, `${key}_${id}`);
      }
      dvm.selected =
        this.derivedVarValues &&
        Object.keys(this.derivedVarValues).some((uid) => uid.startsWith(key));
    },
    popSpecialtyId(valueToRemove) {
      const indexToRemove = this.checkedSpecialtyIds.indexOf(valueToRemove);
      if (indexToRemove !== -1) {
        this.checkedSpecialtyIds.splice(indexToRemove, 1); // Remove element from array
      }
    },
    onLocationInput: function (dvm, value) {
      if (value) {
        this.$set(this.derivedVarValues, 'userZipcode', value);
        dvm.selected = true;
      } else {
        this.$delete(this.derivedVarValues, 'userZipcode');
        dvm.selected = false;
      }
    },
    onAreaCodeInput: function (dvm, value) {
      if (value) {
        this.areaCode = [value];
        this.isOpen = true;
        // this.$set(this.derivedVarValues, 'userAreacode', value);
        // dvm.selected = true;
      } else {
        this.isOpen = false;
        this.areaCode = [];
        // this.$delete(this.derivedVarValues, 'userAreacode');
      }
    },
    getFilters: function () {
      const membershipTypeIds = { ...this.membershipTypeIds };
      
      const { derivedVarNames, derivedVarValues } = this.getDerivedVariables();
      
      const { variableIds, variableValues } = this.getVariables();
      const areacodeName = ["areacode_"+this.areaCode[0]];      
      const areacodeValue = this.areaCode;
      const filterValues = {
        membershipTypeIds,
        derivedVarValues,
        variableValues,
        areacodeName
      };
      const filters = {
        derivedVarNames,
        membershipType: this.membershipTypeIds.length > 0,
        variableIds,
        areacodeValue
      };
      return { filterValues, filters };
    },
    getVariables: function () {
      return this.sections
        .flatMap(({ questions }) => questions)
        .reduce(
          (
            { variableIds, variableValues },
            { question: { id: qId, type }, variables }
          ) => {
            variableValues = variables.reduce(
              (res, { variable: { id: vId }, selected }) => {
                if (selected) {
                  variableIds.push(vId);
                }
                if (selected && type === QUESTION_TYPES.YES_NO) {
                  res[`${qId}_${vId}`] = this.variableValues[`${qId}_${vId}`];
                } else if (
                  selected &&
                  [QUESTION_TYPES.SLIDER, QUESTION_TYPES.CONFIRMATION].includes(
                    type
                  )
                ) {
                  res[`${qId}_${vId}_minmax`] =
                    this.variableValues[`${qId}_${vId}_minmax`];
                } else if (
                  selected &&
                  type === QUESTION_TYPES.MULTI_VARIABLE_SELECT_ONE
                ) {
                  res[`${qId}_${vId}`] = this.variableValues[`${qId}_${vId}`];
                } else if (selected) {
                  res[`${qId}_${vId}`] = 1;
                }
                return res;
              },
              variableValues
            );
            return { variableIds, variableValues };
          },
          { variableIds: [], variableValues: {} }
        );
    },
    getDerivedVariables: function () {
      const derVarValuesKeys = Object.keys(this.derivedVarValues);
      const { derivedVarNames, derivedVarValues } =
        this.derivedVariables.reduce(
          (
            { derivedVarNames, derivedVarValues },
            { derivedVariable: { name }, selected }
          ) => {
            if (selected && name === 'userZipcode') {
              derivedVarValues['userZipcode'] =
                this.derivedVarValues['userZipcode'];
              derivedVarNames.push(name);
            } else {
              derivedVarValues = derVarValuesKeys
                .filter(
                  (key) =>
                    this.derivedVarValues.hasOwnProperty(key) &&
                    key.includes(name) &&
                    this.derivedVarValues[key] === 1
                )
                .reduce((res, key) => {
                  res[key] = 1;
                  derivedVarNames.push(name);
                  return res;
                }, derivedVarValues);
            }
            return { derivedVarNames, derivedVarValues };
          },
          { derivedVarNames: [], derivedVarValues: {} }
        );
      return { derivedVarNames, derivedVarValues };
    },
    getNumberOfSelectedFiltersForSection: function (section) {
      if (!section || !section.questions || !this.selectedVariableValues)
        return 0;
      const questionIds =
        section.questions.map(
          (questionSection) => questionSection.question.id
        ) || [];
      let numberOfSelectedFilters = 0;
      Object.keys(this.selectedVariableValues).forEach((svvId) => {
        questionIds.forEach((qId) => {
          if (svvId.indexOf(qId + '_') === 0) {
            numberOfSelectedFilters++;
          }
        });
      });
      return numberOfSelectedFilters;
    },
    getNumberOfSelectedFiltersForQuestion: function (question) {
      if (!question || !this.selectedVariableValues) return 0;
      let numberOfSelectedFilters = 0;
      Object.keys(this.selectedVariableValues).forEach((svvId) => {
        if (svvId.indexOf(question.id + '_') === 0) {
          numberOfSelectedFilters++;
        }
      });
      return numberOfSelectedFilters;
    },
    getNumberOfSelectedProfileSectionFilters: function () {
      return this.derivedVariables.reduce((res, dv) => {
        return Object.keys(this.derivedVarValues).reduce((res, uid) => {
          if (uid.startsWith(dv.derivedVariable.name) &&
              !uid.startsWith("userSpecialtyId") &&
              !uid.startsWith("userSubSpecialtyId")
            ) {
            res += 1;
          }
          return res;
        }, res);
      }, 0);
    },
    getNumberOfSelectedSpecialtyFilters: function () {
      return this.derivedVariables.reduce((res, dv) => {
        return Object.keys(this.derivedVarValues).reduce((res, uid) => {
          if (uid.startsWith(dv.derivedVariable.name) &&
              uid.startsWith("userSpecialtyId")
            ) {
            res += 1;
          }
          return res;
        }, res);
      }, 0);
    },
     getNumberOfSelectedSubspecialtyFilters: function () {
      return this.derivedVariables.reduce((res, dv) => {
        return Object.keys(this.derivedVarValues).reduce((res, uid) => {
          if (uid.startsWith(dv.derivedVariable.name) &&
              uid.startsWith("userSubSpecialtyId")
            ) {
            res += 1;
          }
          return res;
        }, res);
      }, 0);
    },
    getNumberOfSelectedProfileFilters: function (key) {
      if (!this.derivedVarValues) return 0;
      return Object.keys(this.derivedVarValues).filter((uid) =>
        uid.startsWith(key)
      ).length;
    },
    onClearAll: function () {
      this.derivedVarValues = [];
      this.derivedVariables.forEach((dvm) => {
        dvm.selected = false;
      });
      this.areaCode = [];
      this.isOpen = false;
      this.sections
        .flatMap(({ questions }) => questions)
        .flatMap(({ variables }) => variables)
        .forEach((vm) => {
          this.resetSelectedForVariableModel(vm);
        });
      this.$nextTick(() => {
        this.oldFilters = cloneDeep(this.filters);
        this.isApplyButtonVisible = false;
        this.$emit('filters-apply', this.getFilters());
      });
    },
    onFiltersApply: function () {
      this.oldFilters = cloneDeep(this.filters);
      this.isApplyButtonVisible = false;
      this.$emit('filters-apply', this.getFilters());
    },
    getVariableTags: function () {
      const variableTags = {};
      this.sections
        .flatMap(({ questions }) => questions)
        .forEach(({ question: { id: qId, type, label }, variables }) => {
          variables.forEach(
            ({
              variable: {
                id: vId,
                input_label: variableTag,
                prefix,
                suffix,
                variableOptions,
              },
              selected,
            }) => {
              if (selected) {
                if (!variableTags[qId]) {
                  variableTags[qId] = {
                    label,
                    type,
                    variables: {},
                  };
                }
                if (!variableTags[qId].variables[vId]) {
                  variableTags[qId].variables[vId] = {};
                }
                variableTags[qId].variables[vId].label = variableTag;
              }
              if (selected && type === QUESTION_TYPES.YES_NO) {
                variableTags[qId].variables[vId].label =
                  this.variableValues[`${qId}_${vId}`] === 1 ? 'Yes' : 'No';
              } else if (
                selected &&
                [QUESTION_TYPES.SLIDER, QUESTION_TYPES.CONFIRMATION].includes(
                  type
                )
              ) {
                variableTags[qId].variables[vId].min =
                  this.variableValues[`${qId}_${vId}_minmax`].min;
                variableTags[qId].variables[vId].max =
                  this.variableValues[`${qId}_${vId}_minmax`].max;
                variableTags[qId].variables[vId].prefix = prefix;
                variableTags[qId].variables[vId].suffix = suffix;

                if (variables.length === 1) {
                  delete variableTags[qId].variables[vId].label;
                }
              } else if (
                selected &&
                QUESTION_TYPES.MULTI_VARIABLE_SELECT_ONE &&
                Array.isArray(this.variableValues[`${qId}_${vId}`])
              ) {
                variableTags[qId].variables[vId].values = variableOptions
                  .filter(({ id }) =>
                    this.variableValues[`${qId}_${vId}`].includes(id)
                  )
                  .map(({ name }) => name);
              }
            }
          );
        });

      return variableTags;
    },
    getDerivedTags: function () {
      const derVarValuesKeys = Object.keys(this.derivedVarValues);
      const derivedTags = {};
      this.derivedVariables.forEach(
        ({ derivedVariable: { name, title }, selected }) => {
          if (selected) {
            derivedTags[name] = {
              label: title,
              type: 'DERIVED',
              variables: {},
            };
          }
          if (selected && name === 'userZipcode') {
            const valueString =
              this.derivedVarValues['userZipcode'].value.display_name || '';
            derivedTags[name].variables['userZipcode'] = {
              label: valueString,
            };
          } else {
            derVarValuesKeys.forEach((key) => {
              if (
                this.derivedVarValues.hasOwnProperty(key) &&
                key.includes(name) &&
                this.derivedVarValues[key] === 1
              ) {
                //derivedTags[name].variables[key] = this.derivedVarValues[key];
                const [derivedKey, valueKey] = key.split('_');

                switch (derivedKey) {
                  case 'userSpecialtyId':
                    this.specialties.forEach((s) => {
                      if (s.id === parseInt(valueKey)) {
                        derivedTags[name].variables[valueKey] = {
                          label: s.title,
                        };
                      }
                    });
                    break;
                  case 'userSubSpecialtyId':
                    this.subspecialties.forEach((ss) => {
                      if (ss.id === parseInt(valueKey)) {
                        derivedTags[name].variables[valueKey] = {
                          label: ss.title,
                        };
                      }
                    });
                    break;
                  case 'userGender':
                    this.genderOptions.forEach((g) => {
                      if (g.value === valueKey) {
                        derivedTags[name].variables[valueKey] = {
                          label: g.text,
                        };
                      }
                    });
                    break;
                  case 'userEthnicity':
                    this.ethnicityOptions.forEach((e) => {
                      if (e.value === valueKey) {
                        derivedTags[name].variables[valueKey] = {
                          label: e.text,
                        };
                      }
                    });
                    break;
                }
              }
            });
          }
        }
      );
      return derivedTags;
    },
    getTags: function () {
      return { ...this.derivedTags, ...this.variableTags };
    },
    updateFiltersByTag: function ({ questionId, variableId, isDerived }) {
      if (isDerived) {
        if (questionId === 'userZipcode') {
          this.$delete(this.derivedVarValues, `${variableId}`);
          this.derivedVariables.forEach((dvm) => {
            if (dvm.derivedVariable.name === 'userZipcode') {
              dvm.selected = false;
            }
          });
        } else {
          this.$delete(this.derivedVarValues, `${questionId}_${variableId}`);
        }
      } else {
        this.sections
          .flatMap(({ questions }) => questions)
          .forEach(({ question: { id: qId }, variables }) => {
            if (parseInt(qId) === parseInt(questionId)) {
              variables.forEach((vm) => {
                if (parseInt(vm.variable.id) === parseInt(variableId)) {
                  this.resetSelectedForVariableModel(vm);
                }
              });
            }
          });
      }
      this.$nextTick(() => {
        this.onFiltersApply();
      });
    },
    onMultiSelectChange: function (vm, arrayOfChecked) {
      vm.selected = Array.isArray(arrayOfChecked) && arrayOfChecked.length > 0;
    },
    resetSelectedForVariableModel: function (vm) {
      vm.selected = false;
      if (
        this.variableValues[`${vm.variable.question_id}_${vm.variable.id}`] &&
        Array.isArray(
          this.variableValues[`${vm.variable.question_id}_${vm.variable.id}`]
        )
      ) {
        this.variableValues[`${vm.variable.question_id}_${vm.variable.id}`] =
          [];
      }
    },
    isCompletedModule: function (moduleId) {
      return !!this.completedModules.find((m) => m.id === moduleId);
    },
  },
  created: function () {
    if(this.isUser)
    {
      this.getData();
    }
  },
  watch: {
    filters: function (newFilters) {
      this.isApplyButtonVisible = !isEqual(this.oldFilters, newFilters);
    },
    checkedSpecialtyIds: {
      handler: 'updateSubspecialties', // Method name to call when checkedSpecialtyIds changes
      immediate: true, // Trigger the handler immediately on component mount
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../../sass/variables_mixins';

.filters-selector__section {
  min-height: 50px;
}

.filters-selector__section-header {
  min-height: 50px;
}

.filters-selector__question-id {
  position: absolute;
  top: 10px;
  right: 50px;
  color: #bbb;
  font-size: 80%;
}

.filters-selector__variable-label {
  display: inline-block;
  text-indent: 0 !important;
}

.filters-selector__section_question_label {
  line-height: 35px;
}

.toggle-collapse {
  i.mdi-chevron-up::before {
    @include transform(rotate(0deg));
    @include transition(all 0.2s ease-in-out);
  }
}

.toggle-collapse.collapsed {
  i.mdi-chevron-up::before {
    @include transform(rotate(-180deg));
    @include transition(all 0.2s ease-in-out);
  }
}
.v2_phairify-select-wrapper .custom-select {
padding: 7px !important;
}
</style>
